export const FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_INIT = "FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_INIT";

export const FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST = {
  START: "FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST_START",
  SUCCESS: "FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST_SUCCESS",
  ERROR: "FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST_ERROR",
};

export const EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK = {
  START: "EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK_START",
  SUCCESS: "EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK_SUCCESS",
  ERROR: "EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK_ERROR",
};

export const TOAST = {
  RESET: "RESET_TOAST",
};

export const SET_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS = "SET_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS";
export const CLEAR_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS = "CLEAR_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS";
